import React, { useState } from 'react';

/**
 * Accordion Component
 * 
 * A collapsible content component that allows users to toggle the visibility of content sections.
 * 
 * @component
 * @example
 * <Accordion>
 *   <AccordionItem value="Item 1">
 *     Content for item 1
 *   </AccordionItem>
 * </Accordion>
 */
export function Accordion({ children, type = 'single', collapsible = true, className }) {
  return (
    <div className={`accordion ${className}`}>
      {children}
    </div>
  );
}

export function AccordionItem({ children, value }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  return (
    <div className="border-b border-gray-200">
      <AccordionTrigger onClick={toggleAccordion}>
        {value}
      </AccordionTrigger>
      {isOpen && <AccordionContent>{children}</AccordionContent>}
    </div>
  );
}

export function AccordionTrigger({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full text-left py-4 px-6 font-semibold text-neutral-green-800 hover:bg-gray-100"
    >
      {children}
    </button>
  );
}

export function AccordionContent({ children }) {
  return (
    <div className="px-6 py-4 text-neutral-green-600">
      {children}
    </div>
  );
}
